/** Вертикальный разделитель групп элементов в компактных панелях. */
import type { HTMLAttributes } from "react";

export const VerticalDivider = ({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) => (
	<div className={`mx-1 h-5 border-l border-border ${className}`} {...props} />
);
